// extracted by mini-css-extract-plugin
module.exports = {"percentageLabel":"DonutPercentage-module__percentageLabel___2IGzY"};